<template>
  <div class="document-table-wrapper">
    <table class="pdf-table mt20">
      <tr>
        <td class="td25">
          <div class="pdf-logo-center">
            <div>
              <img src="../../../assets/img/pdf/bce.jpg" width="100%" />
            </div>
          </div>
        </td>
        <td class="td50">
          <div
            class="text-center text-bold"
            style="width:100%; border-bottom: 1px solid grey; font-size:20px"
          >
            BERAU COAL GREEN MINING SYSTEM
          </div>
          <div
            class="text-center text-bold"
            style="width:100%; font-size: 13px"
          >
            FORMULIR INFORMASI VENDOR DAN KELENGKAPAN LEGALITAS
          </div>
          <div
            class="text-center text-bold"
            style="width:100%; font-size: 13px"
          >
            BERBENTUK BADAN USAHA
          </div>
          <div
            class="text-center text-bold"
            style="width:100%; font-size: 11px; font-style: italic"
          >
            ENTITY VENDOR INFORMATION AND LEGALITY REQUIREMENT
          </div>
        </td>
        <td class="td25">
          <div class="pdf-small-text text-center">F-SPM-01.01</div>
          <div class="pdf-small-text text-center">
            {{ formatFullDate(Date.now()) }}
          </div>
          <div class="pdf-small-text text-center">Page 1 of 4</div>
        </td>
      </tr>
      <tr>
        <td colspan="3" class="pdf-text text-right text-bold">
          DI ISI DENGAN HURUF BESAR
        </td>
      </tr>
    </table>

    <table class="pdf-table">
      <tr>
        <td class="td5  no-border"></td>
        <td class="td8 no-border"></td>
        <td class="td20 no-border"></td>
        <td class="td2  no-border"></td>
        <td class="td13 no-border"></td>
        <td class="td13 no-border"></td>
        <td class="td13 no-border"></td>
        <td class="td13 no-border"></td>
        <td class="td13 no-border"></td>
      </tr>
      <tr>
        <td colspan="3" class="pdf-text text-bold">
          NAMA PEMASOK / KONTRAKTOR
        </td>
        <td class="pdf-text text-center text-bold">:</td>
        <td colspan="5" class="pdf-text text-bold">
          {{ $route.query.nama_vendor }}
        </td>
      </tr>
      <tr>
        <td colspan="3" class="pdf-text text-bold">KEGIATAN USAHA UTAMA</td>
        <td class="pdf-text text-center text-bold">:</td>
        <td colspan="5" class="pdf-text text-bold">
          {{
            `${$route.query.kbli1 ? $route.query.kbli1 : ''}${
              $route.query.kbli2 ? `,${$route.query.kbli2}` : ''
            }${$route.query.kbli3 ? `,${$route.query.kbli3}` : ''}`
          }}
        </td>
      </tr>
      <tr>
        <td colspan="3" class="pdf-text text-bold">
          ALAMAT SESUAI FAKTUR PAJAK (Nama Gedung & Jalan)
        </td>
        <td class="pdf-text text-center text-bold">:</td>
        <td colspan="5" class="pdf-text text-bold">
          {{ $route.query.alamat }}
        </td>
      </tr>
      <tr>
        <td class="right-no-border"></td>
        <td colspan="2" class="pdf-text text-bold left-no-border">
          Kel. & Kec.
        </td>
        <td class="pdf-text text-center text-bold">:</td>
        <td colspan="5" class="pdf-text text-bold">
          {{ $route.query.kec }}
        </td>
      </tr>
      <tr>
        <td class="right-no-border"></td>
        <td colspan="2" class="pdf-text text-bold left-no-border">
          Kota & Provinsi
        </td>
        <td class="pdf-text text-center text-bold">:</td>
        <td colspan="5" class="pdf-text text-bold">
          {{ $route.query.kota }}
        </td>
      </tr>
      <tr>
        <td class="right-no-border"></td>
        <td colspan="2" class="pdf-text text-bold left-no-border">
          Kode Pos
        </td>
        <td class="pdf-text text-center text-bold">:</td>
        <td colspan="5" class="pdf-text text-bold">
          {{ $route.query.kodepos }}
        </td>
      </tr>
      <tr>
        <td colspan="3" class="pdf-text text-bold">NAMA DIREKTUR UTAMA</td>
        <td class="pdf-text text-center text-bold">:</td>
        <td colspan="5" class="pdf-text text-bold">
          {{ $route.query.nama }}
        </td>
      </tr>
      <tr>
        <td colspan="3" class="pdf-text text-bold">
          TELEPON/HANDPHONE (DIREKTUR UTAMA)
        </td>
        <td class="pdf-text text-center text-bold">:</td>
        <td colspan="5" class="pdf-text text-bold">
          {{ $route.query.phone_dir }}
        </td>
      </tr>
      <tr>
        <td colspan="3" class="pdf-text text-bold">
          NAMA PERSON IN CHARGE
        </td>
        <td class="pdf-text text-center text-bold">:</td>
        <td colspan="5" class="pdf-text text-bold">
          {{ $route.query.nama_pic }}
        </td>
      </tr>
      <tr>
        <td colspan="3" class="pdf-text text-bold">
          TELEPON/HANDPHONE (PERSON IN CHARGE)
        </td>
        <td class="pdf-text text-center text-bold">:</td>
        <td colspan="5" class="pdf-text text-bold">
          {{ $route.query.phone_pic }}
        </td>
      </tr>
      <tr>
        <td colspan="3" class="pdf-text text-bold">
          EMAIL PERSON IN CHARGE
        </td>
        <td class="pdf-text text-center text-bold">:</td>
        <td colspan="5" class="pdf-text text-bold">
          {{ $route.query.email_pic }}
        </td>
      </tr>
      <tr>
        <td colspan="3" class="pdf-text text-bold">EMAIL PERUSAHAAN</td>
        <td class="pdf-text text-center text-bold">:</td>
        <td colspan="5" class="pdf-text text-bold">
          {{ $route.query.email }}
        </td>
      </tr>
      <tr>
        <td colspan="3" class="pdf-text text-bold">EMAIL DIREKTUR</td>
        <td class="pdf-text text-center text-bold">:</td>
        <td colspan="5" class="pdf-text text-bold">
          {{ $route.query.email_direktur }}
        </td>
      </tr>
      <tr>
        <td colspan="3" class="pdf-text text-bold">BANK DETAIL</td>
        <td class="pdf-text text-center text-bold">:</td>
        <td colspan="5" class="pdf-text text-bold"></td>
      </tr>
      <tr>
        <td class="right-no-border"></td>
        <td colspan="2" class="pdf-text text-bold left-no-border">
          Nama Bank
        </td>
        <td class="pdf-text text-center text-bold">:</td>
        <td colspan="5" class="pdf-text text-bold">
          {{ $route.query.nama_bank }}
        </td>
      </tr>
      <tr>
        <td class="right-no-border"></td>
        <td colspan="2" class="pdf-text text-bold left-no-border">
          Kantor Cabang
        </td>
        <td class="pdf-text text-center text-bold">:</td>
        <td colspan="5" class="pdf-text text-bold">
          {{ $route.query.bank_cabang }}
        </td>
      </tr>
      <tr>
        <td class="right-no-border"></td>
        <td colspan="2" class="pdf-text text-bold left-no-border">
          Nama Pemilik Rekening
        </td>
        <td class="pdf-text text-center text-bold">:</td>
        <td colspan="5" class="pdf-text text-bold">
          {{ $route.query.pemilik_rekening }}
        </td>
      </tr>
      <tr>
        <td class="right-no-border"></td>
        <td colspan="2" class="pdf-text text-bold left-no-border">
          Nomor Rekening Bank
        </td>
        <td class="pdf-text text-center text-bold">:</td>
        <td colspan="5" class="pdf-text text-bold">
          {{ $route.query.no_rek }}
        </td>
      </tr>
      <tr>
        <td class="right-no-border"></td>
        <td colspan="2" class="pdf-text text-bold left-no-border">
          Mata Uang
        </td>
        <td class="pdf-text text-center text-bold">:</td>
        <td colspan="5" class="pdf-text text-bold">
          {{ $route.query.mata_uang }}
        </td>
      </tr>
      <tr>
        <td colspan="9" class="no-border pdf-text text-bold">
          Dengan ini menyatakan hal-hal sebagai berikut:
        </td>
      </tr>
      <tr>
        <td class="no-border pdf-text text-top-center text-bold">1.</td>
        <td colspan="8" class="no-border pdf-text text-bold">
          Susunan Pemegang Saham terkini:
        </td>
      </tr>
      <tr>
        <td class="no-border"></td>
        <td colspan="3" class="pdf-text text-bold text-center">
          Nama Pemegang Saham
        </td>
        <td colspan="2" class="pdf-text text-bold text-center">% Saham</td>
        <td colspan="2" class=" pdf-text text-bold text-center">
          Nama Pemegang Saham
        </td>
        <td class="pdf-text text-bold text-center">% Saham</td>
      </tr>
      <tr>
        <td class="no-border">&shy;</td>
        <td colspan="3" class="pdf-text text-bold text-center">
          {{ $route.query.pemegang_saham1 }}
        </td>
        <td colspan="2" class="pdf-text text-bold text-center">
          {{ $route.query.total_saham1 }}
        </td>
        <td colspan="2" class="pdf-text text-bold text-center">
          {{ $route.query.pemegang_saham4 }}
        </td>
        <td class="pdf-text text-bold text-center">
          {{ $route.query.total_saham4 }}
        </td>
      </tr>
      <tr>
        <td class="no-border">&shy;</td>
        <td colspan="3" class="pdf-text text-bold text-center">
          {{ $route.query.pemegang_saham2 }}
        </td>
        <td colspan="2" class="pdf-text text-bold text-center">
          {{ $route.query.total_saham2 }}
        </td>
        <td colspan="2" class="pdf-text text-bold text-center">
          {{ $route.query.pemegang_saham5 }}
        </td>
        <td class="pdf-text text-bold text-center">
          {{ $route.query.total_saham5 }}
        </td>
      </tr>
      <tr>
        <td class="no-border">&shy;</td>
        <td colspan="3" class="pdf-text text-bold text-center">
          {{ $route.query.pemegang_saham3 }}
        </td>
        <td colspan="2" class="pdf-text text-bold text-center">
          {{ $route.query.total_saham3 }}
        </td>
        <td colspan="2" class="pdf-text text-bold text-center">
          {{ $route.query.pemegang_saham6 }}
        </td>
        <td class="pdf-text text-bold text-center">
          {{ $route.query.total_saham5 }}
        </td>
      </tr>
      <tr>
        <td class="no-border pdf-text text-top-center text-bold">2.</td>
        <td colspan="6" class="no-border pdf-text text-bold">
          Susunan Pengurus terkini:
        </td>
      </tr>
      <tr>
        <td class="no-border"></td>
        <td colspan="3" class="pdf-text text-bold text-center">Jabatan</td>
        <td colspan="2" class="pdf-text text-bold text-center">
          Nama Direksi
        </td>
        <td colspan="2" class="pdf-text text-bold text-center">Jabatan</td>
        <td class=" pdf-text text-bold text-center">Nama Komisaris</td>
      </tr>
      <tr>
        <td class="no-border"></td>
        <td colspan="3" class="pdf-text text-bold text-center">
          Direktur Utama
        </td>
        <td colspan="2" class="pdf-text text-bold text-center">
          {{ $route.query.nama }}
        </td>
        <td colspan="2" class="pdf-text text-bold text-center">
          Komisaris Utama
        </td>
        <td class=" pdf-text text-bold text-center">
          {{ $route.query.komisaris1 }}
        </td>
      </tr>
      <tr>
        <td class="no-border"></td>
        <td colspan="3" class="pdf-text text-bold text-center">Direktur</td>
        <td colspan="2" class="pdf-text text-bold text-center">
          {{ $route.query.direktur1 }}
        </td>
        <td colspan="2" class="pdf-text text-bold text-center">
          Komisaris
        </td>
        <td class=" pdf-text text-bold text-center">
          {{ $route.query.komisaris2 }}
        </td>
      </tr>
      <tr>
        <td class="no-border"></td>
        <td colspan="3" class="pdf-text text-bold text-center">Direktur</td>
        <td colspan="2" class="pdf-text text-bold text-center">
          {{ $route.query.direktur2 }}
        </td>
        <td colspan="2" class="pdf-text text-bold text-center">
          Komisaris
        </td>
        <td class=" pdf-text text-bold text-center">
          {{ $route.query.komisaris3 }}
        </td>
      </tr>
    </table>

    <div class="html2pdf__page-break" />

    <table class="pdf-table mt20">
      <tr>
        <td class="td25">
          <div class="pdf-logo-center">
            <div>
              <img src="../../../assets/img/pdf/bce.jpg" width="100%" />
            </div>
          </div>
        </td>
        <td class="td50">
          <div
            class="text-center text-bold"
            style="width:100%; border-bottom: 1px solid grey; font-size:20px"
          >
            BERAU COAL GREEN MINING SYSTEM
          </div>
          <div
            class="text-center text-bold"
            style="width:100%; font-size: 13px"
          >
            FORMULIR INFORMASI VENDOR DAN KELENGKAPAN LEGALITAS
          </div>
          <div
            class="text-center text-bold"
            style="width:100%; font-size: 13px"
          >
            BERBENTUK BADAN USAHA
          </div>
          <div
            class="text-center text-bold"
            style="width:100%; font-size: 11px; font-style: italic"
          >
            ENTITY VENDOR INFORMATION AND LEGALITY REQUIREMENT
          </div>
        </td>
        <td class="td25">
          <div class="pdf-small-text text-center">F-SPM-01.01</div>
          <div class="pdf-small-text text-center">
            {{ formatFullDate(Date.now()) }}
          </div>
          <div class="pdf-small-text text-center">Page 2 of 4</div>
        </td>
      </tr>
    </table>

    <table class="pdf-table">
      <tr>
        <td class="td5  no-border"></td>
        <td class="td8 no-border"></td>
        <td class="td20 no-border"></td>
        <td class="td2  no-border"></td>
        <td class="td13 no-border"></td>
        <td class="td13 no-border"></td>
        <td class="td13 no-border"></td>
        <td class="td13 no-border"></td>
        <td class="td13 no-border"></td>
      </tr>
      <tr>
        <td class="no-border pdf-text text-top-center text-bold">3.</td>
        <td colspan="5" class="no-border pdf-text text-bold">
          Afiliasi dengan Sinarmas Group:
        </td>
        <td colspan="3" class="no-border pdf-text text-bold">
          Ya / Tidak (pilih salah satu)
        </td>
      </tr>
      <tr>
        <td class="no-border pdf-text text-top-center text-bold"></td>
        <td colspan="5" class="no-border pdf-text">
          Apabila Ya, apa/jelaskan hubungan dengan Sinarmas Mining Group:
        </td>
        <td colspan="3" class="pdf-text">{{ $route.query.afiliasi }}</td>
      </tr>
      <tr>
        <td class="no-border pdf-text text-top-center text-bold">4.</td>
        <td colspan="5" class="no-border pdf-text text-bold">
          Apakah nama yang tertera di dalam dokumen legal memiliki hubungan
          keluarga dengan pemilik atau pejabat yang berwenang di Sinarmas Group:
        </td>
      </tr>
      <tr>
        <td colspan="6" class="no-border"></td>
        <td colspan="3" class="no-border pdf-text text-bold">
          Ya / Tidak (pilih salah satu)
        </td>
      </tr>
      <tr>
        <td class="no-border"></td>
        <td colspan="5" class="pdf-text no-border">
          Apabila Ya, apa/jelaskan hubungan dengan Sinarmas Group:
        </td>
        <td colspan="3" class="pdf-text">{{ $route.query.relasi_desc }}</td>
      </tr>
      <tr>
        <td class="no-border"></td>
        <td colspan="5" class="pdf-text no-border">
          Apa Nama Group Keluarga di Sinarmas Mining Group?
        </td>
        <td colspan="3" class="pdf-text">
          {{ $route.query.relasi_group }}
        </td>
      </tr>
      <tr>
        <td class="no-border"></td>
        <td colspan="5" class="pdf-text no-border pl20">Nama</td>
        <td colspan="3" class="pdf-text">{{ $route.query.relasi_nama }}</td>
      </tr>
      <tr>
        <td class="no-border"></td>
        <td colspan="5" class="pdf-text no-border pl20">Jabatan</td>
        <td colspan="3" class="pdf-text">
          {{ $route.query.relasi_jabatan }}
        </td>
      </tr>
      <tr>
        <td class="no-border"></td>
        <td colspan="5" class="pdf-text no-border pl20">Departemen</td>
        <td colspan="3" class="pdf-text">
          {{ $route.query.relasi_departemen }}
        </td>
      </tr>
      <tr>
        <td colspan="7" class="no-border">&shy;</td>
      </tr>
      <tr>
        <td class="pdf-text text-center text-bold">NO</td>
        <td class="pdf-text text-center text-bold" colspan="2">
          KELENGKAPAN DOKUMEN
        </td>
        <td class="pdf-text text-center text-bold"></td>
        <td class="pdf-text text-center text-bold">KETERSEDIAAN DOKUMEN</td>
        <td class="pdf-text text-center text-bold">TANGGAL BERAKHIR</td>
        <td class="pdf-text text-center text-bold" colspan="3">
          KETERANGAN
        </td>
      </tr>
      <tr>
        <td class="pdf-text text-bold"></td>
        <td class="pdf-text text-bold" colspan="2">Akta Perusahaan :</td>
        <td class="pdf-text text-bold"></td>
        <td class="pdf-text text-bold"></td>
        <td class="pdf-text text-bold"></td>
        <td class="pdf-text text-bold" colspan="3"></td>
      </tr>
      <tr v-for="(item, index) in akta" :key="index">
        <td class="pdf-text text-center">{{ index + 1 }}</td>
        <td class="pdf-text" colspan="2">{{ item.name }}</td>
        <td class="pdf-text text-center">:</td>
        <td class="pdf-text">
          {{ $route.query[`akta${item.id}`] == 'YES' ? 'YES' : 'NO' }}
        </td>
        <td class="pdf-text">
          {{
            $route.query[`akta${item.id}end`]
              ? $route.query[`akta${item.id}end`]
              : '-'
          }}
        </td>
        <td class="pdf-text" colspan="3">
          {{
            $route.query[`akta${item.id}keterangan`]
              ? $route.query[`akta${item.id}keterangan`]
              : '-'
          }}
        </td>
      </tr>
    </table>

    <div class="html2pdf__page-break" />

    <table class="pdf-table mt20">
      <tr>
        <td class="td25">
          <div class="pdf-logo-center">
            <div>
              <img src="../../../assets/img/pdf/bce.jpg" width="100%" />
            </div>
          </div>
        </td>
        <td class="td50">
          <div
            class="text-center text-bold"
            style="width:100%; border-bottom: 1px solid grey; font-size:20px"
          >
            BERAU COAL GREEN MINING SYSTEM
          </div>
          <div
            class="text-center text-bold"
            style="width:100%; font-size: 13px"
          >
            FORMULIR INFORMASI VENDOR DAN KELENGKAPAN LEGALITAS
          </div>
          <div
            class="text-center text-bold"
            style="width:100%; font-size: 13px"
          >
            BERBENTUK BADAN USAHA
          </div>
          <div
            class="text-center text-bold"
            style="width:100%; font-size: 11px; font-style: italic"
          >
            ENTITY VENDOR INFORMATION AND LEGALITY REQUIREMENT
          </div>
        </td>
        <td class="td25">
          <div class="pdf-small-text text-center">F-SPM-01.01</div>
          <div class="pdf-small-text text-center">
            {{ formatFullDate(Date.now()) }}
          </div>
          <div class="pdf-small-text text-center">Page 3 of 4</div>
        </td>
      </tr>
    </table>

    <table class="pdf-table">
      <tr>
        <td class="td5  no-border"></td>
        <td class="td8 no-border"></td>
        <td class="td20 no-border"></td>
        <td class="td2  no-border"></td>
        <td class="td13 no-border"></td>
        <td class="td13 no-border"></td>
        <td class="td13 no-border"></td>
        <td class="td13 no-border"></td>
        <td class="td13 no-border"></td>
      </tr>

      <tr>
        <td class="pdf-text text-bold"></td>
        <td class="pdf-text text-bold" colspan="2">Komersial:</td>
        <td class="pdf-text text-bold"></td>
        <td class="pdf-text text-bold"></td>
        <td class="pdf-text text-bold"></td>
        <td class="pdf-text text-bold" colspan="3"></td>
      </tr>

      <tr v-for="(item, index) in komersil" :key="index">
        <td class="pdf-text text-center">{{ index + 5 }}</td>
        <td class="pdf-text" colspan="2">{{ item.name }}</td>
        <td class="pdf-text text-center">:</td>
        <td class="pdf-text">
          {{ $route.query[`akta${item.id}`] == 'YES' ? 'YES' : 'NO' }}
        </td>
        <td class="pdf-text">
          {{
            $route.query[`akta${item.id}end`]
              ? $route.query[`akta${item.id}end`]
              : '-'
          }}
        </td>
        <td class="pdf-text" colspan="3">
          <the-mask
            class="vendor-input text-bold"
            :mask="['##.###.###.#-###.###']"
            :value="
              $route.query[`akta${item.id}keterangan`]
                ? $route.query[`akta${item.id}keterangan`]
                : ''
            "
            style="border:none;"
            v-if="item.name == 'NPWP (Nomor Pokok Wajib Pajak).'"
          />
          <p v-else>
            {{
              $route.query[`akta${item.id}keterangan`]
                ? $route.query[`akta${item.id}keterangan`]
                : '-'
            }}
          </p>
        </td>
      </tr>

      <tr>
        <td class="pdf-text text-bold"></td>
        <td class="pdf-text text-bold" colspan="2">Perizinan:</td>
        <td class="pdf-text text-bold"></td>
        <td class="pdf-text text-bold"></td>
        <td class="pdf-text text-bold"></td>
        <td class="pdf-text text-bold" colspan="3"></td>
      </tr>
      <tr v-for="(item, index) in izin" :key="index">
        <td class="pdf-text text-center">{{ index + 12 }}</td>
        <td class="pdf-text" colspan="2">{{ item.name }}</td>
        <td class="pdf-text text-center">:</td>
        <td class="pdf-text">
          {{ $route.query[`akta${item.id}`] == 'YES' ? 'YES' : 'NO' }}
        </td>
        <td class="pdf-text">
          {{
            $route.query[`akta${item.id}end`]
              ? $route.query[`akta${item.id}end`]
              : '-'
          }}
        </td>
        <td class="pdf-text" colspan="3">
          {{
            $route.query[`akta${item.id}keterangan`]
              ? $route.query[`akta${item.id}keterangan`]
              : '-'
          }}
        </td>
      </tr>
    </table>

    <div class="html2pdf__page-break" />

    <table class="pdf-table mt20">
      <tr>
        <td class="td25">
          <div class="pdf-logo-center">
            <div>
              <img src="../../../assets/img/pdf/bce.jpg" width="100%" />
            </div>
          </div>
        </td>
        <td class="td50">
          <div
            class="text-center text-bold"
            style="width:100%; border-bottom: 1px solid grey; font-size:20px"
          >
            BERAU COAL GREEN MINING SYSTEM
          </div>
          <div
            class="text-center text-bold"
            style="width:100%; font-size: 13px"
          >
            FORMULIR INFORMASI VENDOR DAN KELENGKAPAN LEGALITAS
          </div>
          <div
            class="text-center text-bold"
            style="width:100%; font-size: 13px"
          >
            BERBENTUK BADAN USAHA
          </div>
          <div
            class="text-center text-bold"
            style="width:100%; font-size: 11px; font-style: italic"
          >
            ENTITY VENDOR INFORMATION AND LEGALITY REQUIREMENT
          </div>
        </td>
        <td class="td25">
          <div class="pdf-small-text text-center">F-SPM-01.01</div>
          <div class="pdf-small-text text-center">
            {{ formatFullDate(Date.now()) }}
          </div>
          <div class="pdf-small-text text-center">Page 4 of 4</div>
        </td>
      </tr>
    </table>

    <table class="pdf-table">
      <tr>
        <td class="td5  no-border"></td>
        <td class="td8 no-border"></td>
        <td class="td20 no-border"></td>
        <td class="td2  no-border"></td>
        <td class="td13 no-border"></td>
        <td class="td13 no-border"></td>
        <td class="td13 no-border"></td>
        <td class="td13 no-border"></td>
        <td class="td13 no-border"></td>
      </tr>
      <tr v-for="(item, index) in izin2" :key="index">
        <td class="pdf-text text-center">{{ index + 23 }}</td>
        <td class="pdf-text" colspan="2">{{ item.name }}</td>
        <td class="pdf-text text-center">:</td>
        <td class="pdf-text">
          {{ $route.query[`akta${item.id}`] == 'YES' ? 'YES' : 'NO' }}
        </td>
        <td class="pdf-text">
          {{
            $route.query[`akta${item.id}end`]
              ? $route.query[`akta${item.id}end`]
              : '-'
          }}
        </td>
        <td class="pdf-text" colspan="3">
          {{
            $route.query[`akta${item.id}keterangan`]
              ? $route.query[`akta${item.id}keterangan`]
              : '-'
          }}
        </td>
      </tr>
      <tr>
        <td class="no-border">&shy;</td>
      </tr>
      <tr>
        <td colspan="9" class="no-border pdf-text text-underline">
          * Note: Pengesahan Akta Perusahaan adalah sebagai berikut:
        </td>
      </tr>
      <tr>
        <td class="pdf-text text-center no-border">1.</td>
        <td class="pdf-text no-border">PT</td>
        <td colspan="7" class="pdf-text no-border">
          : pengesahan/persetujuan/penerimaan pemberitahuan dari Departemen
          Hukum dan HAM RI
        </td>
      </tr>
      <tr>
        <td class="pdf-text text-center no-border">2.</td>
        <td class="pdf-text no-border">CV</td>
        <td colspan="7" class="pdf-text no-border">
          : pengesahan dari Kementerian Hukum dan Hak Asasi Manusia Republik
          Indonesia
        </td>
      </tr>
      <tr>
        <td class="pdf-text text-center no-border">3.</td>
        <td class="pdf-text no-border">Koperasi</td>
        <td colspan="7" class="pdf-text no-border">
          : pengesahan dari Kanwil Koperasi setempat
        </td>
      </tr>
      <tr>
        <td class="pdf-text text-center no-border">4.</td>
        <td colspan="8" class="pdf-text no-border">
          Formulir ini wajib ditandatangani oleh
          <strong>DIREKTUR UTAMA</strong> atau yg Dikuasakannya
        </td>
      </tr>
      <tr>
        <td class="no-border">&shy;</td>
      </tr>
      <div class="html2pdf__page-break" />
      <tr style="border-top: 1px solid grey !important;">
        <td class="no-border">&shy;</td>
      </tr>
      <tr>
        <td colspan="9" class="pdf-text no-border">
          Apabila terjadi dugaan Pelanggaran Kode Etik Pengadaan Barang dan
          Jasa, silahkan menghubungi salah satu Hotline Pengaduan:
        </td>
      </tr>
      <tr>
        <td colspan="9" class="pdf-text no-border">
          a. Telepon, SMS atau WhatApp ke nomor 0881-1511212; atau
        </td>
      </tr>
      <tr>
        <td colspan="9" class="pdf-text no-border">
          b. Surat elektronik (Email) ditujukan ke alamat:
          hotline.procurement@sinarmasming.com;
        </td>
      </tr>
      <tr>
        <td colspan="9" class="pdf-text no-border">
          Setiap laporan mengenai harus dilengkapi dengan bukti sebagai dokumen
          pendukung dan kerahasiaan Anda akan Kami jamin.
        </td>
      </tr>
      <tr style="border-bottom: 1px solid grey !important">
        <td class="no-border">&shy;</td>
      </tr>
      <tr>
        <td class="no-border">&shy;</td>
      </tr>
      <tr>
        <td colspan="9" class="pdf-text no-border">
          Sehubungan dengan apa yang telah kami nyatakan dan serahkan
          sebagaimana tesebut di atas, dengan ini kami menyatakan bahwa seluruh
          salinan/fotocopi dokumen yang kami berikan adalah benar, sesuai dengan
          aslinya dan masih berlaku pada saat ditandatanganinya Pernyataan ini.
          Bahwa apabila salah satu/seluruh dokumen yang kami serahkan dan/atau
          apa yang kami nyatakan dalam Pernyataan ini adalah tidak benar maka
          kami bersedia untuk bertanggung jawab secara hukum atas Pernyataan
          ini.
        </td>
      </tr>
      <tr>
        <td class="no-border">&shy;</td>
      </tr>
      <tr>
        <td colspan="6" class="no-border"></td>
        <td colspan="3" class="pdf-text no-border">
          ____________ , {{ formatFullDate(Date.now()) }}
        </td>
      </tr>
      <tr>
        <td class="no-border">&shy;</td>
      </tr>
      <tr>
        <td colspan="6" class="no-border"></td>
        <td colspan="3" class="pdf-small-text no-border">Meterai</td>
      </tr>
      <tr>
        <td colspan="6" class="no-border"></td>
        <td colspan="3" class="pdf-small-text no-border">Rp.10.000,-</td>
      </tr>
      <tr>
        <td colspan="6" class="no-border"></td>
        <td colspan="3" class="pdf-small-text no-border">
          ___________________________
        </td>
      </tr>
      <tr>
        <td colspan="6" class="no-border"></td>
        <td colspan="3" class="pdf-text no-border">
          Nama : {{ $route.query.nama }}
        </td>
      </tr>
      <tr>
        <td colspan="6" class="no-border"></td>
        <td colspan="3" class="pdf-text no-border">
          <div style="width:80%;border-bottom: 2px solid black">
            Jabatan : {{ $route.query.jabatan }}
          </div>
        </td>
      </tr>
      <tr>
        <td class="no-border">&shy;</td>
      </tr>
    </table>
  </div>
</template>

<script>
import html2pdf from 'html2pdf.js'

export default {
  components: {
    GlobalLoading: () => import('@/components/V2/GlobalLoading.vue'),
  },
  data() {
    return {
      isVisible: false,
      isLoading: false,
      akta: [
        {
          id: 1,
          name:
            'Akta Pendirian Perseroan  dan Pengesahan dari Instansi yang berwenang atas Anggaran Dasar. *',
        },
        {
          id: 2,
          name:
            'Akta penyesuaian PT sesuai dengan Undang-undang No. 40 tahun 2007 dan Pengesahan dari Instansi yang berwenang atas Anggaran Dasar. *',
        },
        {
          id: 3,
          name:
            'Anggaran Dasar terakhir Perseroan / BNRI terakhir dan Pengesahan dari Instansi yang berwenang atas Anggaran Dasar. *',
        },
        {
          id: 4,
          name:
            'Akta perubahan pengurus terakhir Perseroan dan Persetujuan/Penerimaan Pemberitahuan dari Instansi yang berwenang. *',
        },
      ],
      komersil: [
        { id: 5, name: 'NPWP (Nomor Pokok Wajib Pajak).' },
        { id: 6, name: 'SK Pengukuhan Pengusaha Kena Pajak (PKP).' },
        { id: 8, name: 'SKT (Surat Keterangan Terdaftar) Pajak.' },
        { id: 34, name: 'Halaman depan buku tabungan/cek/giro' },
        {
          id: 3536,
          name:
            'KTP semua Direksi & Komisaris yang masih berlaku sesuai Anggaran Perubahan Terakhir.',
        },
        { id: 9, name: 'Company Profile.' },
        {
          id: 10,
          name: 'Finiancial Report/ Annual Report 2-5 tahun terakhir.',
        },
      ],
      izin: [
        { id: 12, name: 'NIB (Nomor Induk Berusaha).' },
        { id: 14, name: 'SIUP (Surat Izin Usaha Perdagangan).' },
        { id: 16, name: 'Izin Usaha Jasa Pertambangan (IUJP)' },
        { id: 17, name: 'Sertifikat Badan Usaha Jasa Konstruksi (SBUJK)' },
        { id: 18, name: 'Izin Usaha Jasa Perusahaan Tenaga Listrik (IUJPTL)' },
        {
          id: 11,
          name: 'Surat Keterangan Domisili / Surat Izin Tempat Usaha (SITU).',
        },
        { id: 13, name: 'TDP (Tanda Daftar Perusahaan).' },
        { id: 19, name: 'Izin Usaha Niaga Umum Bahan Bakar Minyak (INU BBM)' },
        { id: 20, name: 'Surat Izin Usaha Perusahaan Angkatan Laut (SIUPAL)' },
        { id: 21, name: 'Izin Perusahaan Penyedia Tenaga Kerja Jasa / Buruh' },
        { id: 22, name: 'Surat Izin Usaha Perusahaan Bongkar Muat (SIUPBM)' },
      ],
      izin2: [
        { id: 23, name: 'Surat Izin Usaha Jasa Survey (SIUJS)' },
        { id: 37, name: 'Izin Usaha Angkutan Sungai Danau' },
        {
          id: 24,
          name:
            'Surat Izin Usaha Pengurusan Angkutan Jasa / Transportasi (SIUJPT)',
        },
        { id: 26, name: 'Surat Izin Pengelolaan Limbah (SIPL)' },
      ],
    }
  },
  methods: {
    async exportToPDF() {
      this.isVisible = true
      this.isLoading = true
      await html2pdf(this.$refs.document, {
        margin: 0.2,
        filename: 'Formulir Vendor Badan Usaha BCE.pdf',
        image: { type: 'jpeg', quality: 1 },
        html2canvas: { scale: 4, dpi: 192, letterRendering: true },
        jsPDF: { unit: 'in', format: 'a4', orientation: 'portrait' },
      })
      this.isVisible = false
      this.isLoading = false
    },
  },
}
</script>
